import { useMemo } from 'react';

import { useAccountContext } from '@/lib/accounts/account-context';

import { Dropdown, DropdownMenuItem } from '../dropdown';
import { Icon } from '../icon';

import styles from './header.module.scss';

export const AccountMenu = () => {
  const accountContext = useAccountContext();
  const selectedAccount = accountContext.account;

  const accounts = useMemo(
    () => accountContext.accounts.slice().sort((a, b) => a.name.localeCompare(b.name)),
    [accountContext.accounts],
  );

  if (selectedAccount === null) {
    return <></>;
  }

  const menuItems: DropdownMenuItem[] = accounts.map<DropdownMenuItem>((account) => ({
    label: account.name,
    type: 'link',
    href: `/${account.slug}`,
    icon:
      account.accountId === selectedAccount.accountId ? (
        <Icon name="Check" size={16} />
      ) : (
        <div className={styles.emptyIcon} />
      ),
    className: account.accountId === selectedAccount.accountId ? styles.activeItem : styles.item,
  }));

  return (
    <Dropdown
      className={styles.accountMenu}
      items={menuItems}
      align="left"
      trigger={(isOpen, setIsOpen) => (
        <button className={styles.accountMenuButton} onClick={() => setIsOpen(!isOpen)}>
          <div>{selectedAccount.name}</div>
          <Icon name="ChevronDown" size={16} />
        </button>
      )}
    />
  );
};
